import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import components to route to
import { FlybackComponent } from './containers/flyback/flyback.component';

const bookingRoutes: Routes = [
  {
    path: 'fly-back-details',
    component: FlybackComponent
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(bookingRoutes)
  ],
  exports: [
    RouterModule
  ]
})

export class FlybackBookingRoutingModule { }
